<template>
    <aside class="admin-sidebar" :class="{ 'admin-sidebar--collapsed': recolhida, 'admin-sidebar--open': layout.mobileOpen }"
        aria-label="Navegação administrativa">

        <!-- Marca -->
        <div class="admin-sidebar__brand">
            <span class="admin-sidebar__logo admin-sidebar__logo--dark" aria-hidden="true">
                <img :src="logoIconDark" alt="">
            </span>
            <span class="admin-sidebar__logo admin-sidebar__logo--light" aria-hidden="true">
                <img :src="logoIconLight" alt="">
            </span>

            <!-- Recolhida, o logo cede lugar ao botão de expandir (mesma posição, mesmo tamanho). -->
            <button type="button" class="admin-icon-btn admin-sidebar__expand" @click="alternarRecolhida"
                aria-label="Expandir menu" v-tooltip="{ content: 'Expandir menu', placement: 'right' }">
                <i class="ri-menu-unfold-line"></i>
            </button>

            <div class="admin-sidebar__brand-text">
                <span class="admin-sidebar__brand-name">{{ nomeEmpresa }}</span>
                <span class="admin-sidebar__brand-sub">Admin</span>
            </div>

            <button type="button" class="admin-icon-btn admin-sidebar__collapse" @click="alternarRecolhida"
                aria-label="Recolher menu" v-tooltip="{ content: 'Recolher menu', placement: 'right' }">
                <i class="ri-menu-fold-line"></i>
            </button>

            <button type="button" class="admin-icon-btn admin-sidebar__close" @click="fecharMobile"
                aria-label="Fechar menu">
                <i class="ri-close-line"></i>
            </button>
        </div>

        <!-- Navegação -->
        <nav class="admin-sidebar__nav">
            <ul>
                <li class="admin-sidebar__section" aria-hidden="true">Gestão</li>

                <ButtonNavBarAdmin :active="path == '/admin-contas'" @click="acessar_pagina('/admin-contas')" text="Contas"
                    icon="ri-briefcase-5-line"></ButtonNavBarAdmin>

                <ButtonNavBarAdmin :active="path == '/admin-usuarios'" @click="acessar_pagina('/admin-usuarios')"
                    text="Usuários" icon="ri-group-line"></ButtonNavBarAdmin>

                <ButtonNavBarAdmin :active="path == '/admin-inboxes'" @click="acessar_pagina('/admin-inboxes')"
                    text="Inboxes" icon="ri-inbox-line"/>

                <ButtonNavBarAdmin :active="path == '/admin-administradores'"
                    @click="acessar_pagina('/admin-administradores')" text="Administradores" icon="ri-admin-line">
                </ButtonNavBarAdmin>

                <li class="admin-sidebar__section" aria-hidden="true">Infraestrutura</li>

                <ButtonNavBarAdmin :active="path == '/admin-ambientes'"
                    @click="acessar_pagina('/admin-ambientes')" text="Ambientes de e-mail" icon="ri-instance-line">
                </ButtonNavBarAdmin>

                <ButtonNavBarAdmin :active="path == '/admin-servidores'"
                    @click="acessar_pagina('/admin-servidores')" text="Servidores" icon="ri-server-line">
                </ButtonNavBarAdmin>

                <li class="admin-sidebar__section" aria-hidden="true">Monitoramento</li>

                <ButtonNavBarAdmin :active="path == '/admin-auditoria'"
                    @click="acessar_pagina('/admin-auditoria')" text="Auditoria" icon="ri-eye-line">
                </ButtonNavBarAdmin>

                <ButtonNavBarAdmin :active="path == '/admin-user-auditoria'"
                    @click="acessar_pagina('/admin-user-auditoria')" text="Audit. Usuários" icon="ri-user-search-line">
                </ButtonNavBarAdmin>

                <ButtonNavBarAdmin :active="path == '/admin-analise-risco'"
                    @click="acessar_pagina('/admin-analise-risco')" text="Análise de Risco" icon="ri-shield-flash-line">
                </ButtonNavBarAdmin>

                <ButtonNavBarAdmin :active="path == '/admin-mensagens-diarias'"
                    @click="acessar_pagina('/admin-mensagens-diarias')" text="Msgs Diárias" icon="ri-bar-chart-2-line">
                </ButtonNavBarAdmin>

                <ButtonNavBarAdmin :active="path == '/admin-relatorio-uso'"
                    @click="acessar_pagina('/admin-relatorio-uso')" text="Uso (Meta)" icon="ri-pie-chart-2-line">
                </ButtonNavBarAdmin>

                <!-- Grupo: Logs -->
                <li class="admin-nav-item">
                    <button type="button" class="admin-nav-link admin-nav-link--danger" :class="{ 'is-active': grupoAtivo('logs') && (!showLogsMenu || recolhida) }"
                        :aria-expanded="String(showLogsMenu)" aria-controls="admin-nav-logs"
                        @click="alternarGrupo('showLogsMenu')" v-tooltip="tooltipGrupo('Logs')">
                        <i class="ri-bug-line admin-nav-link__icon" aria-hidden="true"></i>
                        <span class="admin-nav-link__text">Logs</span>
                        <i class="ri-arrow-right-s-line admin-nav-link__chevron" aria-hidden="true"></i>
                    </button>
                    <ul v-show="showLogsMenu && !recolhida" id="admin-nav-logs" class="admin-nav-sub" @click.stop>
                        <ButtonNavBarAdmin :active="path == '/admin-logs-erro'"
                            @click="acessar_pagina('/admin-logs-erro')" text="Erro" icon="ri-alert-line">
                        </ButtonNavBarAdmin>
                        <ButtonNavBarAdmin :active="path == '/admin-logs-conexao'"
                            @click="acessar_pagina('/admin-logs-conexao')" text="Conexão" icon="ri-wifi-line">
                        </ButtonNavBarAdmin>
                        <ButtonNavBarAdmin :active="path == '/admin-logs-canais'"
                            @click="acessar_pagina('/admin-logs-canais')" text="Canais" icon="ri-git-branch-line">
                        </ButtonNavBarAdmin>
                    </ul>
                </li>

                <!-- Grupo: Trilhas — os registros de diagnóstico com retenção (o que a Meta
                     mandou, como os onboardings correram, sincronização de contatos e por que
                     cada fluxo de bot fez o que fez). -->
                <li class="admin-nav-item">
                    <button type="button" class="admin-nav-link" :class="{ 'is-active': grupoAtivo('trilhas') && (!showTrilhas || recolhida) }"
                        :aria-expanded="String(showTrilhas)" aria-controls="admin-nav-trilhas"
                        @click="alternarGrupo('showTrilhas')" v-tooltip="tooltipGrupo('Trilhas')">
                        <i class="ri-route-line admin-nav-link__icon" aria-hidden="true"></i>
                        <span class="admin-nav-link__text">Trilhas</span>
                        <i class="ri-arrow-right-s-line admin-nav-link__chevron" aria-hidden="true"></i>
                    </button>
                    <ul v-show="showTrilhas && !recolhida" id="admin-nav-trilhas" class="admin-nav-sub" @click.stop>
                        <ButtonNavBarAdmin :active="path == '/admin-bot-trilha'"
                            @click="acessar_pagina('/admin-bot-trilha')" text="Bots" icon="ri-robot-line">
                        </ButtonNavBarAdmin>
                        <ButtonNavBarAdmin :active="path == '/admin-meta-webhooks'"
                            @click="acessar_pagina('/admin-meta-webhooks')" text="Webhooks Meta" icon="ri-inbox-archive-line">
                        </ButtonNavBarAdmin>
                        <ButtonNavBarAdmin :active="path == '/admin-meta-onboarding'"
                            @click="acessar_pagina('/admin-meta-onboarding')" text="Onboarding Meta" icon="ri-node-tree">
                        </ButtonNavBarAdmin>
                        <ButtonNavBarAdmin :active="path == '/admin-contatos-trilha'"
                            @click="acessar_pagina('/admin-contatos-trilha')" text="Sincronização de Contatos" icon="ri-contacts-book-line">
                        </ButtonNavBarAdmin>
                    </ul>
                </li>

                <li class="admin-sidebar__section" aria-hidden="true">Integrações</li>

                <ButtonNavBarAdmin :active="path == '/admin-webhooks'"
                    @click="acessar_pagina('/admin-webhooks')" text="Webhooks" icon="ri-webhook-line">
                </ButtonNavBarAdmin>

                <ButtonNavBarAdmin :active="path == '/admin-api-keys'"
                    @click="acessar_pagina('/admin-api-keys')" text="Chaves de API" icon="ri-key-2-line">
                </ButtonNavBarAdmin>

                <ButtonNavBarAdmin :active="path == '/admin-meta-templates'"
                    @click="acessar_pagina('/admin-meta-templates')" text="Templates Meta" icon="ri-chat-check-line">
                </ButtonNavBarAdmin>

                <ButtonNavBarAdmin :active="path == '/admin-meta-template-eventos'"
                    @click="acessar_pagina('/admin-meta-template-eventos')" text="Eventos de Templates" icon="ri-history-line">
                </ButtonNavBarAdmin>

                <ButtonNavBarAdmin :active="path == '/admin-meta-migracao-roteiro'"
                    @click="acessar_pagina('/admin-meta-migracao-roteiro')" text="Migração Templates" icon="ri-git-merge-line">
                </ButtonNavBarAdmin>

                <ButtonNavBarAdmin :active="path == '/admin-whatsapp-wame'"
                    @click="acessar_pagina('/admin-whatsapp-wame')" text="WhatsApp WAME" icon="ri-swap-box-line">
                </ButtonNavBarAdmin>

                <ButtonNavBarAdmin :active="path == '/admin-meta-graph-console'"
                    @click="acessar_pagina('/admin-meta-graph-console')" text="Console da Graph" icon="ri-terminal-box-line">
                </ButtonNavBarAdmin>

                <!-- Grupo: Integrações -->
                <li class="admin-nav-item">
                    <button type="button" class="admin-nav-link" :class="{ 'is-active': grupoAtivo('integracoes') && (!showIntegracoes || recolhida) }"
                        :aria-expanded="String(showIntegracoes)" aria-controls="admin-nav-integracoes"
                        @click="alternarGrupo('showIntegracoes')" v-tooltip="tooltipGrupo('Integrações')">
                        <i class="ri-plug-line admin-nav-link__icon" aria-hidden="true"></i>
                        <span class="admin-nav-link__text">Integrações</span>
                        <i class="ri-arrow-right-s-line admin-nav-link__chevron" aria-hidden="true"></i>
                    </button>
                    <ul v-show="showIntegracoes && !recolhida" id="admin-nav-integracoes" class="admin-nav-sub" @click.stop>
                        <ButtonNavBarAdmin :active="path == '/admin-integracao-remsono'"
                            @click="acessar_pagina('/admin-integracao-remsono')" text="Remsono" icon="ri-send-plane-line">
                        </ButtonNavBarAdmin>
                    </ul>
                </li>

                <!-- Grupo: Bot IA -->
                <li class="admin-nav-item">
                    <button type="button" class="admin-nav-link" :class="{ 'is-active': grupoAtivo('botIa') && (!showBotIa || recolhida) }"
                        :aria-expanded="String(showBotIa)" aria-controls="admin-nav-bot-ia"
                        @click="alternarGrupo('showBotIa')" v-tooltip="tooltipGrupo('Bot IA')">
                        <i class="ri-robot-2-line admin-nav-link__icon" aria-hidden="true"></i>
                        <span class="admin-nav-link__text">Bot IA</span>
                        <i class="ri-arrow-right-s-line admin-nav-link__chevron" aria-hidden="true"></i>
                    </button>
                    <ul v-show="showBotIa && !recolhida" id="admin-nav-bot-ia" class="admin-nav-sub" @click.stop>
                        <ButtonNavBarAdmin :active="path == '/admin-relatorios-bot-ia'"
                            @click="acessar_pagina('/admin-relatorios-bot-ia')" text="Relatórios (IA)" icon="ri-dashboard-3-line">
                        </ButtonNavBarAdmin>
                        <ButtonNavBarAdmin :active="path == '/admin-relatorios-bot-ia-sem-whiz'"
                            @click="acessar_pagina('/admin-relatorios-bot-ia-sem-whiz')" :text="`Relatórios (sem ${branding.shortName})`" icon="ri-line-chart-line">
                        </ButtonNavBarAdmin>
                        <ButtonNavBarAdmin v-if="authStoreAdmin.adminInfo?.root" :active="path == '/admin-bot-ia-app'"
                            @click="acessar_pagina('/admin-bot-ia-app')" text="App completo" icon="ri-apps-2-line">
                        </ButtonNavBarAdmin>
                        <!-- Root-only pela mesma razão do "App completo": os escopos de token dos
                             formulários embarcados são plataforma-wide (alcançam qualquer
                             instância/agente), então o limite de acesso é o admin root do whiz. -->
                        <ButtonNavBarAdmin v-if="authStoreAdmin.adminInfo?.root" :active="path == '/admin-bot-ia-forms'"
                            @click="acessar_pagina('/admin-bot-ia-forms')" text="Instâncias e Agentes" icon="ri-settings-4-line">
                        </ButtonNavBarAdmin>
                    </ul>
                </li>

                <li class="admin-sidebar__section" aria-hidden="true">Conteúdo</li>

                <ButtonNavBarAdmin :active="path == '/admin-novidades'"
                    @click="acessar_pagina('/admin-novidades')" text="Novidades" icon="ri-sparkling-line">
                </ButtonNavBarAdmin>

                <ButtonNavBarAdmin :active="path == '/admin-faqs'"
                    @click="acessar_pagina('/admin-faqs')" text="FAQ" icon="ri-question-answer-line">
                </ButtonNavBarAdmin>

                <!-- Grupo: Banco de Conhecimento -->
                <li class="admin-nav-item">
                    <button type="button" class="admin-nav-link" :class="{ 'is-active': grupoAtivo('bancoConhecimento') && (!showBancoConhecimento || recolhida) }"
                        :aria-expanded="String(showBancoConhecimento)" aria-controls="admin-nav-banco"
                        @click="alternarGrupo('showBancoConhecimento')" v-tooltip="tooltipGrupo('Banco de Conhecimento')">
                        <i class="ri-book-open-line admin-nav-link__icon" aria-hidden="true"></i>
                        <span class="admin-nav-link__text">Banco de Conhecimento</span>
                        <i class="ri-arrow-right-s-line admin-nav-link__chevron" aria-hidden="true"></i>
                    </button>
                    <ul v-show="showBancoConhecimento && !recolhida" id="admin-nav-banco" class="admin-nav-sub" @click.stop>
                        <ButtonNavBarAdmin :active="path == '/admin-banco-conhecimento-modulos'"
                            @click="acessar_pagina('/admin-banco-conhecimento-modulos')" text="Módulos" icon="ri-folder-line">
                        </ButtonNavBarAdmin>
                        <ButtonNavBarAdmin :active="path == '/admin-banco-conhecimento-videos'"
                            @click="acessar_pagina('/admin-banco-conhecimento-videos')" text="Vídeos" icon="ri-video-line">
                        </ButtonNavBarAdmin>
                    </ul>
                </li>

                <li class="admin-sidebar__section" aria-hidden="true">Ajuda</li>

                <ButtonNavBarAdmin @click="acessar_documentacao()" text="Documentação" icon="ri-article-line">
                </ButtonNavBarAdmin>
            </ul>
        </nav>

        <!-- Rodapé: identidade do administrador, tema e saída -->
        <div class="admin-sidebar__footer">
            <div class="admin-sidebar__user">
                <span class="admin-sidebar__avatar" aria-hidden="true">{{ iniciaisAdmin }}</span>
                <div class="admin-sidebar__user-text">
                    <span class="admin-sidebar__user-name" :title="authStoreAdmin.adminInfo?.nome">
                        {{ authStoreAdmin.adminInfo?.nome || 'Administrador' }}
                    </span>
                    <span class="admin-sidebar__user-mail" :title="authStoreAdmin.adminInfo?.email">
                        {{ authStoreAdmin.adminInfo?.email || '' }}
                    </span>
                </div>
                <div class="admin-sidebar__user-actions">
                    <button type="button" class="admin-icon-btn" @click="uiStore.changeTheme()"
                        :aria-label="uiStore.theme === 'light' ? 'Ativar tema escuro' : 'Ativar tema claro'"
                        v-tooltip="{ content: uiStore.theme === 'light' ? 'Tema escuro' : 'Tema claro', placement: 'top' }">
                        <i :class="uiStore.theme === 'light' ? 'ri-moon-line' : 'ri-sun-line'"></i>
                    </button>
                    <button type="button" class="admin-icon-btn admin-nav-link--danger" @click="logout()"
                        aria-label="Sair" v-tooltip="{ content: 'Sair', placement: 'top' }">
                        <i class="ri-logout-circle-r-line"></i>
                    </button>
                </div>
            </div>
        </div>

    </aside>
</template>

<script>
import { urlDaDocumentacaoApi } from '@/utils/urlDaApi';
import { useAuthStoreAdmin } from '@/stores/admin/authAdmin';
import { useUiStore } from '@/stores/app/uiStore';
import { branding } from '@/config/branding';
import { useCompanyLogo } from '@/composables/useCompanyLogo';
import ButtonNavBarAdmin from './ButtonNavBarAdmin.vue';
import { adminLayoutState, alternarSidebarRecolhida, fecharSidebarMobile, sidebarRecolhidaEfetiva } from './adminLayoutState';

// Estado de abertura dos grupos sobrevive à troca de página (a lateral é
// remontada a cada rota), por isso fica no módulo e não na instância.
let _logsMenuOpen = false;
let _integracoesMenuOpen = false;
let _botIaMenuOpen = false;
let _bancoConhecimentoMenuOpen = false;
let _trilhasMenuOpen = false;

/** Rotas de cada grupo: abre o grupo sozinho quando uma delas é a página atual. */
const ROTAS_GRUPO = {
    logs: ['/admin-logs-erro', '/admin-logs-conexao', '/admin-logs-canais'],
    integracoes: ['/admin-integracao-remsono'],
    botIa: ['/admin-relatorios-bot-ia', '/admin-relatorios-bot-ia-sem-whiz', '/admin-bot-ia-app', '/admin-bot-ia-forms'],
    bancoConhecimento: ['/admin-banco-conhecimento-modulos', '/admin-banco-conhecimento-videos'],
    trilhas: ['/admin-bot-trilha', '/admin-meta-webhooks', '/admin-meta-onboarding', '/admin-contatos-trilha'],
};

export default {
    name: 'NavBarLeftAdmin',
    components: { ButtonNavBarAdmin },
    props: {
        path: {
            type: String
        }
    },
    provide() {
        return {
            // Getter (e não valor) para o filho reagir à mudança sem precisar de watcher.
            sidebarRecolhida: sidebarRecolhidaEfetiva,
        };
    },
    setup() {
        const { logoIconLight, logoIconDark } = useCompanyLogo();
        return { logoIconLight, logoIconDark, layout: adminLayoutState };
    },
    data() {
        return {
            branding,
            authStoreAdmin: useAuthStoreAdmin(),
            uiStore: useUiStore(),
            nomeEmpresa: branding.shortName || branding.companyName,
            showLogsMenu: _logsMenuOpen || ROTAS_GRUPO.logs.includes(this.path),
            showIntegracoes: _integracoesMenuOpen || ROTAS_GRUPO.integracoes.includes(this.path),
            showBotIa: _botIaMenuOpen || ROTAS_GRUPO.botIa.includes(this.path),
            showBancoConhecimento: _bancoConhecimentoMenuOpen || ROTAS_GRUPO.bancoConhecimento.includes(this.path),
            showTrilhas: _trilhasMenuOpen || ROTAS_GRUPO.trilhas.includes(this.path),
        }
    },
    computed: {
        /** Recolhida de fato: no mobile a gaveta sempre mostra os rótulos. */
        recolhida() {
            return sidebarRecolhidaEfetiva();
        },
        iniciaisAdmin() {
            const nome = (this.authStoreAdmin.adminInfo?.nome || '').trim();
            if (!nome) return 'A';
            const partes = nome.split(/\s+/);
            const iniciais = partes.length > 1
                ? partes[0][0] + partes[partes.length - 1][0]
                : nome.slice(0, 2);
            return iniciais.toUpperCase();
        },
    },
    watch: {
        showLogsMenu(val) {
            _logsMenuOpen = val;
        },
        showIntegracoes(val) {
            _integracoesMenuOpen = val;
        },
        showBotIa(val) {
            _botIaMenuOpen = val;
        },
        showTrilhas(val) {
            _trilhasMenuOpen = val;
        },
        showBancoConhecimento(val) {
            _bancoConhecimentoMenuOpen = val;
        },
    },
    methods: {
        async logout() {
            await this.authStoreAdmin.logout();
            this.$router.push('/admin')
        },
        acessar_pagina(path) {
            fecharSidebarMobile();
            this.$router.push(path)
        },
        acessar_documentacao() {
            // F-55: o host fixo de dev não tinha DNS; cada ambiente abre o próprio Swagger.
            window.open(urlDaDocumentacaoApi(), '_blank', 'noopener')
        },
        alternarGrupo(chave) {
            // Recolhida, os subitens ficam escondidos e o grupo vira um só ícone;
            // clicar nele expande a lateral já com o grupo aberto.
            if (this.recolhida) {
                alternarSidebarRecolhida();
                this[chave] = true;
                return;
            }
            this[chave] = !this[chave];
        },
        grupoAtivo(grupo) {
            return ROTAS_GRUPO[grupo].includes(this.path);
        },
        tooltipGrupo(texto) {
            return { content: texto, placement: 'right', distance: 10, disabled: !this.recolhida };
        },
        alternarRecolhida() {
            alternarSidebarRecolhida();
        },
        fecharMobile() {
            fecharSidebarMobile();
        },
        aoTeclar(evento) {
            if (evento.key === 'Escape' && this.layout.mobileOpen) fecharSidebarMobile();
        },
    },
    mounted() {
        window.addEventListener('keydown', this.aoTeclar);
    },
    beforeUnmount() {
        window.removeEventListener('keydown', this.aoTeclar);
        // A lateral é remontada a cada rota; a gaveta nunca deve "vazar" aberta.
        fecharSidebarMobile();
    },
}
</script>
